import { isArray, isObject, isString } from 'angular';
export var FeaturedProtocolsDirective = [
    'protocolConfiguration',
    function (protocolConfiguration) {
        return {
            link: function ($scope, $element) {
                if (!isArray($scope.protocols) || $scope.protocols.length === 0) {
                    return;
                }
                protocolConfiguration.get().then(function (configuration) {
                    var featuredProtocols = [];
                    var _loop_1 = function (protocol) {
                        var protocolName = configuration.featuredProtocols[protocol];
                        if (!isString(protocolName) || protocolName === '') {
                            return "continue";
                        }
                        var protocolFeature = configuration.features.filter(function (feature) { return feature.name === protocolName; })[0];
                        if (!isObject(protocolFeature) || protocolFeature === null) {
                            return "continue";
                        }
                        featuredProtocols.push({
                            description: protocolFeature.description,
                            name: protocolFeature.name,
                        });
                    };
                    for (var _i = 0, _a = $scope.protocols; _i < _a.length; _i++) {
                        var protocol = _a[_i];
                        _loop_1(protocol);
                    }
                    var _loop_2 = function (feature) {
                        featuredProtocols = featuredProtocols.sort(function (a, b) {
                            if (a.name === b.name) {
                                return 0;
                            }
                            if (a.name === feature.name) {
                                return 1;
                            }
                            if (b.name === feature.name) {
                                return -1;
                            }
                            return 0;
                        });
                    };
                    for (var _b = 0, _c = configuration.features; _b < _c.length; _b++) {
                        var feature = _c[_b];
                        _loop_2(feature);
                    }
                    $scope.featuredProtocol = featuredProtocols[0];
                    if ($scope.featuredProtocol === undefined) {
                        $element.addClass('ng-hide');
                    }
                    else {
                        $element.removeClass('ng-hide');
                    }
                });
            },
            scope: {
                protocolCssClass: '@?',
                protocols: '<',
            },
            template: "\n        <span class=\"{{ protocolCssClass }}\"\n              uib-tooltip-html=\"featuredProtocol.description\"\n              ng-bind=\"featuredProtocol.name\">\n        </span>\n      ",
        };
    },
];
